import { Button, Popover } from '@farol-ds/react'
import { COMPONENT_CLASS, COMPONENT_NAME, SELECTED_OPTION } from '@jusbrasil-web/shared-ga4-events'
import classNames from 'classnames'
import { ReactNode, useEffect } from 'react'

import { useGA4Events } from '../../hooks'
import styles from './hide-focus-visible.module.scss'
import { useFocusRingSuppressedUntilTab } from './use-focus-ring-suppressed-until-tab'

interface NudgePopoverProps {
  children: ReactNode
  onComplete: () => void
  onDismiss: () => void
}

const componentClass = COMPONENT_CLASS.COMPLETE_SIGNUP_NUDGE
const componentName = COMPONENT_NAME.COMPLETE_SIGNUP_NUDGE_POPOVER

const POPOVER_RENDER_PROPS = {
  componentClass,
  componentName,
  renders: [{ item_variant: null, item_brand: null, item_name: componentName, item_id: null }],
}

const POPOVER_CTA_CLICK_PROPS = {
  componentClass,
  componentName,
  selectedOption: SELECTED_OPTION.COMPLETE,
  resourceId: null,
}

const POPOVER_DISMISS_CLICK_PROPS = {
  componentClass,
  componentName,
  selectedOption: SELECTED_OPTION.SKIP,
  resourceId: null,
}

export function NudgePopover({ children, onComplete, onDismiss }: NudgePopoverProps) {
  const ga4 = useGA4Events()
  const suppressFocusRing = useFocusRingSuppressedUntilTab()

  useEffect(() => {
    ga4.sendComponentRender(POPOVER_RENDER_PROPS)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleComplete = () => {
    ga4.sendClick(POPOVER_CTA_CLICK_PROPS)
    onComplete()
  }

  return (
    <Popover
      open
      onOpenChange={(open) => {
        if (!open) {
          ga4.sendClick(POPOVER_DISMISS_CLICK_PROPS)
          onDismiss()
        }
      }}
      placement="bottom-end"
      type="highlight"
    >
      <Popover.Anchor asChild>
        <span>{children}</span>
      </Popover.Anchor>
      <Popover.Content
        className={classNames({ [styles.hideFocusVisible]: suppressFocusRing })}
        style={{ maxWidth: 280, zIndex: 3 }}
        // Persist on outside click — only the X (or esc) dismisses it.
        onInteractOutside={(e) => e.preventDefault()}
        // Portaled content bubbles through the React tree into the Drawer.Trigger button;
        // stop it so clicking the popover doesn't also open the user-menu drawer.
        onClick={(e) => e.stopPropagation()}
      >
        <Popover.ContentClose />
        <Popover.ContentTitle>Complete seu cadastro</Popover.ContentTitle>
        <Popover.ContentDescription>
          Informe seu CPF e data de nascimento pra regularizar sua conta e manter o acesso completo
          à plataforma.
        </Popover.ContentDescription>
        <Popover.ContentFooter>
          <Button kind="tertiary" size="sm" onClick={handleComplete}>
            Completar cadastro
          </Button>
        </Popover.ContentFooter>
      </Popover.Content>
    </Popover>
  )
}
